import "./PropertyThumbnail.css";
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";
//import default_property_image from "/images/default_property_image.png"; // with import

function countFacility(facility_name, facilities) {
  if (facilities.length === 0) {
    return 0;
  }
  let facilityList = facilities.filter(
    (facility) => facility.name === facility_name
  );
  return facilityList.length > 0 ? facilityList[0].quantity : 0;
}

function FeaturedPropertyThumbnail(props) {
  let imageDefault = props.data.images.filter((image) => image.default)[0];
  return (
    <>
      <div className="container-fluid no-padding">
        <div className="row row-no-padding">
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="py-4">
              <div className="section-title section-title--style-1 mb-0">
                <h3 className="section-title-inner heading-sm strong-600 text-uppercase">
                  <span>Propiedad destacada</span>
                </h3>
                <span className="section-title-delimiter clearfix d-none"></span>
              </div>
              <div className="delimiter delimiter--style-1"></div>
              <div className="heading heading-3 strong-400">
                <Nav.Link
                  as={Link}
                  to={{
                    pathname: "/propiedad/" + props.data.code,
                    state: { property: props.data },
                  }}
                ></Nav.Link>
                <h4 className="heading heading-sm strong-400">
                  {props.data.address} ( {props.data.property_type_name} )
                </h4>
              </div>
            </div>
          </div>
        </div>

        <div className="row row-no-padding">
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <h4 className="heading heading-sm strong-400"> </h4>
            <h3 className="heading heading-3 strong-600 c-base-1 mt-4 mb-4">
              {props.data.property_price}
            </h3>

            <p>Descripcion</p>

            <div className="row">
              <div className="col-lg-12">
                <ul className="meta-info-cells meta-info-cells-v4">
                  <li>
                    <i className="fa fa-home"></i> {props.data.area}{" "}
                    <span className="hidden-xs hidden-sm">
                      Metros cuadrados
                    </span>
                  </li>
                  <li>
                    <i className="fa fa-bed"></i> {props.data.rooms_count}{" "}
                    <span className="hidden-xs hidden-sm">Habitaciones</span>
                  </li>
                  <li>
                    <i className="fa fa-tint"></i> {props.data.bathrooms_count}{" "}
                    <span className="hidden-xs hidden-sm">Baños</span>
                  </li>
                  <li>
                    <i className="fa fa-car"></i>{" "}
                    {props.data.parking_slots_count}{" "}
                    <span className="hidden-xs hidden-sm">Parqueaderos</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <a href={"/propiedad/" + props.data.code}>
              {imageDefault === undefined || imageDefault == null ? (
                <img
                  key={props.data.code}
                  className="img-fluid z-depth-3 rounded"
                  src={"/default_property_image.png"}
                  alt={"no_image"}
                />
              ) : (
                <img
                  key={props.data.code}
                  className="img-fluid z-depth-3 rounded"
                  src={imageDefault.url}
                  alt={imageDefault.name}
                />
              )}
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default FeaturedPropertyThumbnail;
